"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var animateDot = exports.animateDot = function animateDot(speed) {
  return "\n@keyframes animateDot {\n  0% {\n    opacity: 0;\n    transform: translateX(-300px);\n  }\n  33% {\n    opacity: 1;\n    transform: translateX(0px);\n  }\n  66% {\n    opacity: 1;\n    transform: translateX(0px);\n  }\n  100% {\n    opacity: 0;\n    transform: translateX(300px);\n  }\n}\nanimation-duration: " + speed + ";\nanimation-iteration-count: infinite;\nanimation-name: animateDot;\nanimation-timing-function: ease-in-out";
};